// TODO типизировать
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { from, Observable, switchMap, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ObserverAuthService } from '../../services/observer-auth.service';

@Injectable()
export class ObserverAuthInterceptor implements HttpInterceptor {
  constructor(
    private readonly router: Router,
    private readonly observerAuthService: ObserverAuthService,
  ) {}

  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const isObserverLink = /observer\/.+/.test(req.url);

    if (isObserverLink) {
      const apiKey = this.observerAuthService.apiKey;

      if (apiKey) {
        return next
          .handle(
            req.clone({
              headers: req.headers.set('RR-Api-Key', apiKey),
            }),
          )
          .pipe(
            catchError((err) =>
              from(this.router.navigate(['/'])).pipe(
                switchMap(() => throwError(() => err)),
              ),
            ),
          );
      }
    }

    return next.handle(req);
  }
}
